import React from "react";

import { NavDropdown } from "react-bootstrap";

import { Link } from "react-router-dom";
import { ROUTES } from "src/routes";

export const UserDropDownMenu: React.FC = () => {
  return (
    <>
      <NavDropdown title="User" renderMenuOnMount>
        <NavDropdown.Item as={Link} to={ROUTES.Dashboard.path}>
          Dashboard
        </NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.Item as={Link} to={ROUTES.SignOut.path}>
          Sign out
        </NavDropdown.Item>
      </NavDropdown>
    </>
  );
};
